import React, { useEffect, useState, useRef } from 'react';
import {
    useGetArticle,
    useGetArticlesByType,
    usePostArticleViewed
} from 'app/services/article-api';
import {
    ArticleStatus,
    ArticleType,
    GetArticleDetailDto,
    GetArticleSummaryDto,
    ListSortDirection
} from 'generated/article-backend';
import ArticleContent from 'app/modules/articles/viewArticle/articleDetail/articleContent/ArticleContent';
import { Loader } from 'app/components/loader/Loader';
import { separateVideosFromHTMLString } from 'app/components/helpers';
import TrainingVideosList from './trainingVideosList/TrainingVideosList';
import './TrainingPortal.scss';
import { Breadcrumb, IBreadcrumbItem } from '@fluentui/react';
import { useHistory, useLocation } from 'react-router';
import NoData from 'app/components/noData/NoData';
import { RouteConstants } from 'app/utils/constants';

const TrainingPortal: React.FC<{}> = () => {
    const location: { state?: string } = useLocation();
    const { mutateAsync: postArticleViewedAPI } = usePostArticleViewed();
    const [trainingContent, setTrainingContent] = useState('');
    const [trainingVideo, setTrainingVideo] = useState('');
    const [articleInfo, setArticleInfo] = useState<GetArticleDetailDto>();
    const history = useHistory();

    const [selectedTrainingArticleID, setSelectedTrainingArticleID] = useState(location?.state ? location?.state : '');

    const {
        isFetched,
        isLoading,
        data: articles
    } = useGetArticlesByType(1, 9999, 'ModifiedOn', ListSortDirection.Descending, null, ArticleStatus.Published, ArticleType.TrainingArticle);

    const {
        data: selectedArticle,
        isLoading: isLoadingArticle,
        isFetched: isFetchedArticle
    } = useGetArticle(selectedTrainingArticleID);

    const portalRef = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            portalRef.current?.setAttribute('aria-label', 'training portal')
        }, 1000)
    }, [])

    useEffect(() => {
        const article = articles?.items?.filter((e: GetArticleSummaryDto) => e.showOnHomePage)[0];
        setSelectedTrainingArticleID(selectedTrainingArticleID ? selectedTrainingArticleID : article?.id);
    }, [isFetched, articles, postArticleViewedAPI]);

    useEffect(() => {
        if (selectedTrainingArticleID && selectedArticle) {
            setArticleInfo(selectedArticle);
            postArticleViewedAPI(selectedTrainingArticleID).catch(() => {});
        }
    }, [selectedTrainingArticleID, selectedArticle, isLoadingArticle, isFetchedArticle]);

    useEffect(() => {
        if (isFetchedArticle && ((articleInfo as GetArticleDetailDto)?.type === ArticleType.TrainingArticle || (articleInfo as GetArticleDetailDto)?.type === ArticleType.TrainingAdminOnlyArticle)) {
            setTrainingContent(separateVideosFromHTMLString((articleInfo as GetArticleDetailDto).content).content);
            setTrainingVideo(separateVideosFromHTMLString((articleInfo as GetArticleDetailDto).content).videos[0]);
        }
    }, [isFetchedArticle, articleInfo]);

    const openTrainingVideo = (id: string) => {
        setSelectedTrainingArticleID(id);
    };
    const itemsWithHref: IBreadcrumbItem[] = [
        { text: 'Home', key: 'home', onClick: () => history.push(RouteConstants.KNOWLEDGE_PORTAL) },
        {
            text: 'Portal Training',
            key: 'Portal Training',
            isCurrentItem: true
        }
    ];
    if (!isLoadingArticle && !isLoading && isFetchedArticle && isFetched) {
        return (
            <div ref={portalRef} aria-label='' aria-live='assertive'>
                {articles?.totalCount > 0 ? (
                    <div aria-hidden='true' className="training-articles">
                        <div className="container">
                            <Breadcrumb items={itemsWithHref} maxDisplayedItems={4} />
                        </div>
                        <div className="container m-t-10">
                            <div className="training-article-details">
                                <ArticleContent
                                    content={trainingContent}
                                    views={articleInfo?.numberOfViews}
                                    isTraining={true}
                                    trainingVideo={trainingVideo}
                                    title={articleInfo?.title}
                                />
                            </div>
                            <div className="training-article-sidebar">
                                {articles?.items?.filter((e: GetArticleSummaryDto) => e.showOnHomePage)?.length > 0 && (
                                    <TrainingVideosList
                                        openThisTraining={openTrainingVideo}
                                        title="Must see"
                                        data={articles.items.filter((e: GetArticleSummaryDto) => e.showOnHomePage)}
                                        activeTrainingId={selectedTrainingArticleID}
                                    />
                                )}
                                {articles?.items?.filter((e: GetArticleSummaryDto) => !e.showOnHomePage)?.length > 0 && (
                                    <TrainingVideosList
                                        openThisTraining={openTrainingVideo}
                                        title="More videos"
                                        data={articles.items.filter((e: GetArticleSummaryDto) => !e.showOnHomePage)}
                                        activeTrainingId={selectedTrainingArticleID}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                ) : (
                    <NoData />
                )}
            </div>
        );
    } else {
        return <Loader classNames="m-t-20 m-b-50 height-70" />;
    }
};

export default TrainingPortal;
